import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { PRODUCTS } from "@/data/content";
import { ProductCard } from "@/components/StoreSection";

const StorePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="store-page" className="bg-[#FAF5EC] min-h-screen text-kiki-ink warm-spotlight">
      <header className="border-b border-kiki-line bg-[#FAF5EC]/85 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
          <Link data-testid="store-back-link" to="/" className="flex items-center gap-2.5 text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300 font-outfit">
            <ArrowLeft className="w-4 h-4" />
            <img src="/logo.png" alt="Kiki Services" className="w-8 h-8 rounded-full object-cover border border-kiki-line" />
            <span className="font-display text-xl text-kiki-ink">Kiki<span className="italic text-kiki-gold">Services</span></span>
          </Link>
          <button data-testid="store-header-cta" onClick={() => navigate("/book")} className="flex items-center gap-1.5 bg-kiki-ink hover:bg-kiki-gold text-[#FAF5EC] text-sm font-outfit font-semibold rounded-full px-5 py-2.5 transition-colors duration-300">
            Book a consultation <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </header>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-20">
        <Reveal><Eyebrow>Ready-to-use templates & kits</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-kiki-ink mt-3 leading-[1.05]">
            Digital product shop
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-4 text-lg text-kiki-muted font-light leading-relaxed max-w-2xl">
            Downloadable business templates, calculators, trackers, checklists, workbooks, dashboards and SOP kits —
            across six shops: HR, Brand &amp; Marketing, Data &amp; BI, Process, Content &amp; Knowledge, and Admin &amp; Operations.
            Add bundles to your shortlist and we finalise everything on a consultation call.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.name} product={p} index={i} />
          ))}
        </div>

        <p className="mt-10 text-sm text-kiki-muted font-light italic">
          Digital products are business aids/templates and may require client-specific customisation.
          Pricing is indicative and varies with scope, volume and complexity.
        </p>
      </section>
    </div>
  );
};

export default StorePage;
